import React, { useEffect, useState } from "react";
import { FaPen } from "react-icons/fa";

const EditOrderModal = ({
    showEditModal,
    setShowEditModal,
    selectedOrder,
    editData,
    setEditData,
    handleEditSubmit,
    loading
}) => {

    // close handler
    const handleClose = () => {
        setShowEditModal(false);
    };

    // handle input change (same old logic)
    const handleChange = (field, value) => {
        setEditData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // ESC close (optional pro touch 🔥)
    useEffect(() => {
        const esc = (e) => {
            if (e.key === "Escape") handleClose();
        };
        document.addEventListener("keydown", esc);
        return () => document.removeEventListener("keydown", esc);
    }, []);

    if (!showEditModal) return null;

    return (
        <div className="oms-overlay">
            <div className="oms-modal">

                {/* HEADER */}
                <div className="oms-modal-head">
                    <span className="oms-modal-title">
                        <FaPen size={16} className="me-2" />
                        Edit Order: <span className="text-uppercase oms-track-id">{selectedOrder?.trackingId}</span>
                    </span>
                    <button className="oms-icon-btn" onClick={handleClose}>✕</button>
                </div>

                {/* BODY */}
                <div className="oms-modal-body">
                    <div className="oms-form-grid">

                        <div className="oms-form-group">
                            <label className="oms-form-label">Customer Name</label>
                            <input
                                className="oms-form-input"
                                value={editData.customerName || ""}
                                onChange={(e) => handleChange("customerName", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Phone Number</label>
                            <input
                                type="number"
                                className="oms-form-input"
                                value={editData.phoneNumber || ""}
                                onChange={(e) => handleChange("phoneNumber", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group oms-form-full">
                            <label className="oms-form-label">Address</label>
                            <textarea
                                className="oms-form-textarea"
                                value={editData.address || ""}
                                onChange={(e) => handleChange("address", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">City</label>
                            <input
                                className="oms-form-input"
                                value={editData.city || ""}
                                onChange={(e) => handleChange("city", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Quantity</label>
                            <input
                                type="number"
                                min="1"
                                className="oms-form-input"
                                value={editData.quantity || 1}
                                onChange={(e) => handleChange("quantity", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Amount</label>
                            <input
                                type="number"
                                className="oms-form-input"
                                value={editData.amount || ""}
                                onChange={(e) => handleChange("amount", e.target.value)}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">VPP Number</label>
                            <input
                                maxLength={11}
                                className="oms-form-input"
                                value={editData.VppNumber || ""}
                                onChange={(e) => handleChange("VppNumber", e.target.value)}
                            />
                        </div>

                    </div>
                </div>

                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="oms-btn oms-btn-primary"
                        onClick={handleEditSubmit}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "💾 Save Changes"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditOrderModal;